import { render, staticRenderFns } from "./ChoiceFilter.vue?vue&type=template&id=161e5da0"
import script from "./ChoiceFilter.vue?vue&type=script&lang=js"
export * from "./ChoiceFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports